
// export const logout = ( state ) => {
// }

export const setTypeproducts = (state, typeproducts) => {
    state.typeproducts = typeproducts
}

export const setTypeproductsSelectable = (state, typeproducts) => {
    state.typeproductsSelectable = typeproducts
}

export const setTypeproductsPaginated = (state, typeproductsPaginatedData) => {
    state.typeproductsPaginatedData = typeproductsPaginatedData
}

export const setTypeproductDetail = (state, typeproduct) => {
    state.typeproduct = typeproduct
}

export const saveNewTypeproducts = (state, typeproduct) => {
    state.typeproducts.unshift(typeproduct)
    state.createdData = typeproduct;
}

export const saveUpdatedTypeproduct = (state, typeproduct) => {
    state.typeproducts.unshift(typeproduct)
    state.updatedData = typeproduct;
}

export const setDeleteTypeproduct = (state, typeproduct) => {
    
    state.typeproductsPaginatedData.data.filter(x => x.id !== typeproduct.id);
    state.deletedData = typeproduct
}

export const setTypeproductIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setTypeproductIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setTypeproductIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setTypeproductIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
